import { ScoreId } from "@appTypes/App.interface"

/**
 * NOTE: Score ids should be pure, we shouldn't be extracting 
 * info from it.
 * 
 * @param scoreId - The score id
 * @returns The parts of the score id
 */
export function getScoreIdParts(scoreId: ScoreId) {
    const [leadId, loanAmount, loanTerm] = scoreId.split(';')

    return {
        leadId,
        loanAmount: Number(loanAmount),
        loanTerm: Number(loanTerm)
    }
}